import { render, staticRenderFns } from "./qzcCollegePage.vue?vue&type=template&id=dbc6efbe&scoped=true"
import script from "./qzcCollegePage.vue?vue&type=script&lang=js"
export * from "./qzcCollegePage.vue?vue&type=script&lang=js"
import style0 from "./qzcCollegePage.vue?vue&type=style&index=0&id=dbc6efbe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc6efbe",
  null
  
)

export default component.exports